module.exports = __webpack_public_path__ + "ec.svg?478bab4ba1859533023121f8095a73d6";